import React from 'react';
import I18n from 'app/i18n';
import ShowMore from 'app/utils/ShowMore';
import LotItem from './LotItem';
import type LotOrderInterface from 'app/interfaces/LotOrderInterface';
import LotArtifactInterface from 'app/interfaces/LotArtifactInterface';

interface LotsForSaleTableProps {
    cancelOrder: (artifact: LotArtifactInterface, id: number) => void
    data: LotOrderInterface[]
    handleLoadMore: () => Promise<void>
    has_more: boolean
    hideHeader?: boolean
    noLotsLabel?: string
}

const LotsForSaleTable = ({
    cancelOrder,
    data,
    handleLoadMore,
    has_more,
    hideHeader,
    noLotsLabel
}: LotsForSaleTableProps): React.ReactElement => <div className="market__lots__items js-table">
    {!hideHeader && <div className="market__lots__items__heading tables-heading">
        <div className="market__lots__items__name-placed">
            <div className="market__lots__items__name">{I18n.t('user.name')}</div>
            <div className="market__lots__items__placed">{I18n.t('listed_on')}</div>
        </div>
        <div className="market__lots__items__price-actions">
            <div className="market__lots__items__price">{I18n.t('price')}</div>
            <div className="market__lots__items__actions"/>
        </div>
    </div>}

    {data.length > 0
        ? data.map((order: LotOrderInterface) => <LotItem
            key={order.id}
            artifact={order.artifact}
            cancelOrder={cancelOrder}
            created_at={order.created_at}
            id={order.id}
            total_price={order.total_price}
        />)
        : <div className="market__lots__item market__lots__item-empty">
            {noLotsLabel || I18n.t('there_are_no_active_lots')}
        </div>}

    <ShowMore onClickHandler={handleLoadMore} has_more={has_more}/>
</div>;

export default LotsForSaleTable;
